import { Presentation, FileDown } from 'lucide-react'
import { Button } from '@/components/ui/Button'

import type { Proposta } from '@/types'
import { PROPOSAL_PDF_EXPORT_ENABLED, PROPOSAL_PPTX_EXPORT_ENABLED } from './proposalFeatureFlags'

interface ExportSectionProps {
  hasProposals: boolean
  proposal?: Proposta
  onExportPPTX?: (proposta?: Proposta) => void
  onExportPDF?: (proposta?: Proposta) => void
}

export function ExportSection({ hasProposals, proposal, onExportPPTX, onExportPDF }: ExportSectionProps) {
  if (!hasProposals) return null
  if (!PROPOSAL_PPTX_EXPORT_ENABLED && !PROPOSAL_PDF_EXPORT_ENABLED) return null

  return (
    <div className="flex gap-2 pt-2 border-t border-white/[0.06]">
      {PROPOSAL_PPTX_EXPORT_ENABLED && onExportPPTX && (
        <Button
          variant="secondary"
          size="sm"
          icon={<Presentation size={13} />}
          onClick={() => onExportPPTX(proposal)}
        >
          Baixar Apresentação (PPTX)
        </Button>
      )}
      {PROPOSAL_PDF_EXPORT_ENABLED && onExportPDF && (
        <Button
          variant="secondary"
          size="sm"
          icon={<FileDown size={13} />}
          onClick={() => onExportPDF(proposal)}
        >
          Anexo 1
        </Button>
      )}
    </div>
  )
}
